import { useMemo, useState } from 'react';

import { List } from 'components/list';
import { Info } from 'components/info';
import { formatDate } from 'utils/date';
import { Row, Col } from 'components/grid';
import { ListCard } from 'components/list-card';
import { InfoBlock } from 'components/info-block';
import { ListHeader } from 'components/list-header';
import { Drawer, DrawerHeader } from 'components/drawer';
import { FiservCaseDetail } from 'store/api/fiserv/types';
import { formatPrice, formatCaseInfo } from 'utils/helpers';

import { FiservListProps } from './types';
import { titles, template, infoItemConfig } from './config';

export const FiservList = ({ data }: FiservListProps) => {
  const [selectedChargeback, setSelectedChargeback] =
    useState<FiservCaseDetail>();

  const infoItems = useMemo(
    () => formatCaseInfo<FiservCaseDetail>(selectedChargeback, infoItemConfig),
    [selectedChargeback]
  );

  const onClose = () => setSelectedChargeback(undefined);

  return (
    <>
      <List
        count={data?.length || 0}
        mainWrapperStyles={{ padding: 0 }}
        header={
          <ListHeader padding="8px" titles={titles} template={template} />
        }
      >
        {data?.map((value) => (
          <ListCard
            headers={titles}
            template={template}
            key={value.RecordID}
            onClick={() => setSelectedChargeback(value)}
            values={[
              formatDate(value.ReportDate),
              formatDate(value.TransactionDate),
              value.CaseNumber,
              value.CardTypeDescription,
              value.CardNumber,
              value.CBTypeDescription,
              formatPrice(value.RepresentedCBAmount || value.TransactionAmount),
              value.Disposition,
            ]}
          />
        ))}
      </List>

      <Drawer
        hideOverlay
        topOffset="20%"
        onClose={onClose}
        opened={!!selectedChargeback}
      >
        <DrawerHeader onClose={onClose} title="Fiserv Chargeback Detail" />

        <InfoBlock>
          <Row>
            {infoItems.map((item, i) => (
              <Col col={3} key={i} colTablet={4}>
                <Info {...item} />
              </Col>
            ))}
          </Row>
        </InfoBlock>
      </Drawer>
    </>
  );
};
